import { notification } from "antd";

const getRejectionMessage = (reason) => {
  if (!reason) {
    return "An unexpected background operation failed.";
  }

  if (typeof reason === "string") {
    return reason;
  }

  return (
    reason.message ||
    reason.responseText ||
    reason.statusText ||
    reason.error?.message ||
    reason.response?.body?.message ||
    reason.response?.text ||
    "An unexpected background operation failed."
  );
};

export const setupUnhandledRejectionGuard = () => {
  if (typeof window === "undefined" || window.__qrUnhandledRejectionGuard) {
    return;
  }

  window.__qrUnhandledRejectionGuard = true;

  window.addEventListener("unhandledrejection", (event) => {
    event.preventDefault();

    const description = getRejectionMessage(event.reason);
    console.error("Unhandled promise rejection:", event.reason || description);

    notification.error({
      key: "unhandled-promise-rejection",
      message: "Operation failed",
      description,
    });
  });
};
